import * as React from "react";
import "./viewContainer.scss";
import {WorkspaceView} from "../../../../model/workspace/WorkspaceView";
import ViewSelector from "../viewSelector/ViewSelector";
import FavouriteItem from "../favorites/FavouriteItem";
import {isDefined} from "../../../../utils/Utils";

interface IProps {
	views: WorkspaceView[];
	selectedView: WorkspaceView;
	favouritesViews: string[];
	onViewSelect: (view: WorkspaceView) => void;
	onRenameView: (view: WorkspaceView) => void;
	onRemoveFromFavourite: (view: WorkspaceView) => void;
	onFavouritesViewsOrderChange: (dragged: number, target: number) => void;
	onAddToFavourites: (viewId: string) => void;
	onDeleteView: (view: WorkspaceView) => void;
	onDuplicateView: (view: WorkspaceView) => void;
	onCopyToMyView: (view: WorkspaceView) => void;
	/**
	 * Ignore selection for displaying selected view.
	 */
	ignoreSelection?: boolean;
}

export default class ViewsContainer extends React.Component<IProps, {}> {

	static MAX_FAVOURITES_VIEW = 8;

	render() {
		const favourites = this.props.favouritesViews.slice(0, ViewsContainer.MAX_FAVOURITES_VIEW)
			.map(vId => this.props.views.filter(v => v.id == vId)[0])
			.filter(v => isDefined(v))
			.map((v, index) =>
				<FavouriteItem key={index}
							   index={index}
							   onViewClick={() => this.props.onViewSelect(v)}
							   item={{
								   id: v.id,
								   isSelected: this.props.ignoreSelection ? false : v.id == this.props.selectedView.id,
								   // TODO fix counter
								   counter: index,
								   name: v.name,
								   onRemove: () => this.props.onRemoveFromFavourite(v),
								   onRename: () => this.props.onRenameView(v)
							   }}
							   onOrderChange={this.props.onFavouritesViewsOrderChange}/>);
		// Views that can be set as favorites
		const filteredVies = this.props.views.slice(1).filter(f => !(this.props.favouritesViews.indexOf(f.id) > -1));
		for (let i = favourites.length; i < ViewsContainer.MAX_FAVOURITES_VIEW; i++) {
			favourites.push(<FavouriteItem key={i}
										   views={filteredVies}
										   onAddToFavourites={this.props.onAddToFavourites}/>);
		}
		return (
			<div className={"c-view-container"}>
				<ViewSelector {...this.props}/>
				{favourites}
			</div>
		)
	}
}